import { Button, Stack, Typography } from '@mui/material'
import Link from 'next/link'
import { EmphasizedNumber } from 'utoniq-ui'

import { Template } from '@/core/architecture'
import { useTranslation } from '@/core/i18n'

type State = {
  useNextRouter: boolean
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
type Action = {}

export const NotFoundTemplate: Template<State, Action> = ({
  state: { useNextRouter = true },
}) => {
  const { t } = useTranslation('notFound')
  return (
    <Stack sx={{ maxWidth: 600, width: '100%', margin: '0 auto' }}>
      <Stack sx={{ pt: 5 }} />
      <Stack sx={{ p: 7, mt: 6 }} alignItems="center">
        <EmphasizedNumber variant="h1">{t('title')}</EmphasizedNumber>
        <Typography variant="h4" sx={{ pt: 2 }}>
          {t('message')}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ pt: 5 }}
          align="center"
        >
          {t('desc')}
        </Typography>
      </Stack>
      <Stack alignItems="center">
        {useNextRouter ? (
          <Link href="/home" passHref>
            <Button component="div" size="large">
              {t('goToTopPage')}
            </Button>
          </Link>
        ) : (
          <Button href="/home" size="large">
            {t('goToTopPage')}
          </Button>
        )}
      </Stack>
    </Stack>
  )
}
